"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHOS_ORGANISATIONS_FILTER_MAP = exports.ORGANISATION_TYPE_FILTER_MAP = void 0;

var _clientAuth = require("@devsta/client-auth");

var ALWAYS_TRUE_FN = function ALWAYS_TRUE_FN() {
  return true;
};

var ONE_DAY_IN_MS = 86400000;
var CURRENT_TIME = new Date().getTime();
var NEW_DATE_THRESHOLD = 30 * ONE_DAY_IN_MS;
var ORGANISATION_TYPE_FILTER_MAP = {
  ALL: ALWAYS_TRUE_FN,
  DRAFT: function DRAFT(organisation) {
    return organisation.status === 'DRAFT';
  },
  NEW: function NEW(_ref) {
    var subPackage = _ref.package;
    return subPackage && subPackage.subStart && CURRENT_TIME - new Date(subPackage.subStart).getTime() <= NEW_DATE_THRESHOLD;
  },
  ACTIVE: function ACTIVE(organisation) {
    return organisation.status !== 'DRAFT';
  },
  RISK: function RISK(organisation) {
    return Boolean(organisation.atRisk);
  }
};
exports.ORGANISATION_TYPE_FILTER_MAP = ORGANISATION_TYPE_FILTER_MAP;

var loggedInUser = _clientAuth.credentials.get().user;

var WHOS_ORGANISATIONS_FILTER_MAP = {
  MINE: function MINE(organisation) {
    return organisation.accountManager && organisation.accountManager.userId === loggedInUser.userId;
  },
  EVERYONE: ALWAYS_TRUE_FN
};
exports.WHOS_ORGANISATIONS_FILTER_MAP = WHOS_ORGANISATIONS_FILTER_MAP;